import { appContext } from '../../../../AppContext';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import { JSX } from 'react';
import { IState as IParentState } from './EditUser';
import { Card, CopyButton, GridContainer, GridItem, OnSectionUpdateHandler, PasswordField, Select, TextField } from '@iconics/components';
import { UserType } from '../../../../Providers.StaticData/StaticDataProvider';

class EditUserConfiguration extends IbssComponent<IProps, IState>
{

    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    }

    public render(): JSX.Element
    {
        return (
            <Card
                title={this.labels.Platform_User_ConfigurationTitle}
                subTitle={this.labels.Platform_User_ConfigurationSubTitle}
                onSectionUpdate={i => this.props.onSectionUpdate(i)}
            >
                <GridContainer>
                    <GridItem expanded={6}>
                        <Select
                            label={this.labels.User_IdentityProviderName}
                            placeholder={this.labels.User_IdentityProviderName}
                            value={[this.props.identityProviderId.toString()]}
                            onSelect={(e) => this.props.handleInputChange('identityProviderId', e.value)}
                            items={this.props.identityProviderOptions}
                            required
                            disabled={!this.props.isNew}
                        />
                    </GridItem>
                    <GridItem expanded={6}>
                        <Select
                            label={this.labels.User_UserType}
                            placeholder={this.labels.User_UserType}
                            onSelect={(e) => this.props.handleInputChange('userType', e.value)}
                            value={[this.props.userType]}
                            items={this.props.userTypeOptions}
                            required={this.props.isNative}
                            disabled={!this.props.isNative || !this.props.isNew}
                        />
                    </GridItem>
                    {
                        (this.props.showPassword) &&
                        <GridItem expanded={6}>
                            <PasswordField
                                required
                                value={this.props.password}
                                label={this.labels.User_UserPassword}
                                placeholder={this.labels.User_UserPassword}
                                invalid={!!this.props.passwordError}
                                invalidMessage={this.props.passwordError}
                                onChange={(e) => this.props.handleInputChange('password', e.target.value)}
                                autoComplete='new-password'
                            />
                        </GridItem>
                    }
                    {
                        (!this.props.isNew && this.props.isNative && this.props.userType == 'App') &&
                        <GridItem expanded={6}>
                            <TextField
                                label={this.labels.User_ApplicationKey}
                                placeholder={this.labels.User_ApplicationKey}
                                value={this.props.applicationKey}
                                disabled={true}
                                rightContent={this.props.isFullApplicationKey ? <CopyButton onClick={() => this.props.applicationKey} /> : undefined}
                            />
                        </GridItem>
                    }
                </GridContainer>
            </Card>
        )
    }
}

export default EditUserConfiguration;

export interface IProps
{
    identityProviderOptions: { value: string, label: string }[];
    identityProviderId: number;
    userTypeOptions: { value: UserType, label: string }[];
    userType: UserType;
    showPassword: boolean;
    password: string;
    passwordError: string;
    applicationKey: string;
    isFullApplicationKey: boolean;
    isNew: boolean;
    isNative: boolean;
    handleInputChange: (fieldName: keyof IParentState, value: IParentState[keyof IParentState]) => void
    onSectionUpdate: OnSectionUpdateHandler;
}

export interface IState 
{

}